(() => {
  let refreshTimeouts = [];
  
  const executeMultipleRefreshChecks = async (reason) => {
    refreshTimeouts.forEach(timeout => clearTimeout(timeout));
    refreshTimeouts = [];
    
    const delays = [1000, 2000, 4000];
    
    delays.forEach((delay, index) => {
      const timeout = setTimeout(async () => {
        try {
          await __CART__CONTROLLER__.get();
          await __CART__CONTROLLER__.reRenderSections();
          await __CART__CONTROLLER__.cleanup();
        } catch (error) {
        }
      }, delay);
      
      refreshTimeouts.push(timeout);
    });
  };

  const executeSingleRefresh = async (reason, delay = 2000) => {
    setTimeout(async () => {
      try {
        await __CART__CONTROLLER__.get();
        await __CART__CONTROLLER__.reRenderSections();
        await __CART__CONTROLLER__.cleanup();
      } catch (error) {
      }
    }, delay);
  };

  document.addEventListener('cart::open', () => {
    executeSingleRefresh('cart opened');
  }, true);

  document.addEventListener('cart::add', () => {
    executeSingleRefresh('item added to cart');
  }, true);

  document.addEventListener('changeQuantity', (e) => {
    executeMultipleRefreshChecks(`quantity changed - key: ${e.detail.key}, value: ${e.detail.value}`);
  }, true);

  document.addEventListener('removeItem', (e) => {
    executeMultipleRefreshChecks(`item removed - key: ${e.detail.key}`);
  }, true);

  const monitorQuantityInputs = () => {
    document.querySelectorAll('hh-quantity-input').forEach(quantityInput => {
      if (!quantityInput.dataset.monitored) {
        quantityInput.addEventListener('click', (e) => {
          const button = e.target.closest('button');
          if (button) {
            const buttonName = button.getAttribute('name');
            if (buttonName === 'plus' || buttonName === 'minus') {
              executeMultipleRefreshChecks(`${buttonName} button clicked directly`);
            }
          }
        }, true);
        
        quantityInput.dataset.monitored = 'true';
      }
    });
  };

  const monitorRemoveButtons = () => {
    document.querySelectorAll('hh-button[custom\\:click="removeItem"]').forEach(removeButton => {
      if (!removeButton.dataset.monitored) {
        removeButton.addEventListener('click', () => {
          executeMultipleRefreshChecks(`remove button clicked - key: ${removeButton.getAttribute('key')}`);
        });
        removeButton.dataset.monitored = 'true';
      }
    });
  };

  const monitorCartClicks = () => {
    const miniCart = document.querySelector('hh-mini-cart');
    if (miniCart && !miniCart.dataset.monitored) {
      miniCart.addEventListener('click', (e) => {
        const button = e.target.closest('button');
        if (button) {
          const buttonName = button.getAttribute('name');
          const isQuantityButton = buttonName === 'plus' || buttonName === 'minus';
          const isRemoveButton = button.closest('hh-button[custom\\:click="removeItem"]');
          
          if (isQuantityButton) {
            executeMultipleRefreshChecks(`${buttonName} button clicked in mini-cart`);
          } else if (isRemoveButton) {
            const key = isRemoveButton.getAttribute('key');
            executeMultipleRefreshChecks(`remove button clicked in mini-cart - key: ${key}`);
          }
        }
      }, true);
      
      miniCart.dataset.monitored = 'true';
    }
  };

  monitorQuantityInputs();
  monitorRemoveButtons();
  monitorCartClicks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches('hh-quantity-input') || node.querySelector('hh-quantity-input')) {
            setTimeout(monitorQuantityInputs, 100);
          }
          
          if (node.matches('hh-button[custom\\:click="removeItem"]') || node.querySelector('hh-button[custom\\:click="removeItem"]')) {
            setTimeout(monitorRemoveButtons, 100);
          }
          
          if (node.matches('hh-mini-cart') || node.querySelector('hh-mini-cart')) {
            setTimeout(monitorCartClicks, 100);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.forceCartRefresh = () => executeMultipleRefreshChecks('manual trigger');

})();